import { Button, Flex, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const gradient =
  "linear-gradient(135deg, #D98A9E 0%, #A82549 100%)";

export default function SidebarDocs() {
  return (
    <Flex
      justify="center"
      direction="column"
      align="center"
      bg={gradient}
      borderRadius="30px"
      me={{ base: "20px" }}
      position="relative"
    >
      <Flex direction="column" mb="12px" align="center" justify="center" px="15px" py="24px">
        <Text
          fontSize={{ base: "lg", xl: "18px" }}
          color="white"
          fontWeight="bold"
          lineHeight="150%"
          textAlign="center"
          px="10px"
          mb="14px"
        >
          Suporte OnlyWine
        </Text>
        <Text fontSize="14px" color="white" px="10px" mb="14px" textAlign="center">
          Dúvidas sobre pedidos ou integração? Fale connosco.
        </Text>
      </Flex>
      <Button
        as={RouterLink}
        to="/partner/support"
        bg="whiteAlpha.300"
        _hover={{ bg: "whiteAlpha.200", textDecoration: "none" }}
        _active={{ bg: "whiteAlpha.100" }}
        mb={{ sm: "16px", xl: "24px" }}
        color="white"
        fontWeight="regular"
        fontSize="sm"
        minW="185px"
        mx="auto"
      >
        Abrir suporte
      </Button>
    </Flex>
  );
}
